module.exports = __webpack_public_path__ + "img/media-bro.90718ddf.svg";